import { format } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

// Localized short time. Locale-driven via date-fns' default locale (set from
// the active i18next language in src/i18n/date-locale). en -> "2:30 PM",
// fr -> "14:30".
export const formatTimeOnly = (date: Date | number | string, timezone?: string): string => {
  if (!date) return '-'
  if (timezone) return formatInTimeZone(new Date(date), timezone, 'p')
  return format(new Date(date), 'p')
}
